import { ButtonVariant } from "@repo/ui/Buttons/button";
import { IconButton } from "@repo/ui/Buttons/iconButton";
import { Size } from "@repo/ui/helpers/helpers";
import { SimpleTooltip } from "@repo/ui/tooltip/simpleTooltip";
import { TooltipTrigger } from "@repo/ui/tooltip/tooltipTrigger";
import { IconColumns3 } from "@tabler/icons-react";
import type { FC } from "react";

/**
 * Icon-button trigger used to open the "Display columns" multi-select menu.
 * Renders as a secondary icon button with a "Display columns" tooltip.
 */
export const DisplayColumnsMenuTrigger: FC = () => {
  return (
    <TooltipTrigger>
      <IconButton
        accessibleLabel="Display columns"
        icon={<IconColumns3 className="size-4 shrink-0 text-gray-700" />}
        size={Size.SMALL}
        variant={ButtonVariant.Secondary}
      />
      <SimpleTooltip>Display columns</SimpleTooltip>
    </TooltipTrigger>
  );
};
